import * as types from "./actionTypes";
import initialState from "./initialState";
import {
  setLoadingInstruments,
  loadFilteredInstruments,
  setInstrumentsError,
} from "./reducer.filteredInstruments";

const withLocationData = (state, key, value) => ({
  ...state,
  locationData: {
    ...state.locationData,
    [key]: value,
  },
});

const handlers = {
  [types.LOAD_ROOM_LIST]: (state, payload) => ({ ...state, roomList: payload }),
  [types.LOAD_BUILDING_LIST]: (state, payload) => ({ ...state, buildingList: payload }),
  [types.LOAD_ADDREASON_LIST]: (state, payload) => ({ ...state, bookingAddReason: payload }),
  [types.LOAD_FLOORS_LIST]: (state, payload) => ({ ...state, floorsList: payload }),
  [types.SET_SITE_ID]: (state, payload) => ({ ...state, siteId: payload }),
  [types.LOAD_SITES_LIST]: (state, payload) => withLocationData(state, "sites", payload),
  [types.SET_ADMIN_SITE_ID]: (state, payload) => withLocationData(state, "adminSiteId", payload),
  [types.LOAD_ADMIN_BUILDINGS]: (state, payload) => withLocationData(state, "adminBuildingsList", payload),
  [types.LOAD_ADMIN_FLOORS]: (state, payload) => withLocationData(state, "adminFloorsList", payload),
  [types.LOAD_ADMIN_ROOMS]: (state, payload) => withLocationData(state, "adminRoomsList", payload),
  [types.APPROVE_BOOKING]: (state) => state,
  [types.REJECT_BOOKING]: (state) => state,
  [types.SET_LOADING_INSTRUMENTS]: setLoadingInstruments,
  [types.LOAD_FILTERED_INSTRUMENTS]: loadFilteredInstruments,
  [types.SET_INSTRUMENTS_ERROR]: setInstrumentsError,
};

export default function reducer(state = initialState, { type, payload } = {}) {
  const handler = handlers[type];
  return handler ? handler(state, payload) : state;
}
